import { Button } from '@mui/material';
import { Launch } from '@mui/icons-material';

import {
  getInfluenceTypeLabel,
  getLocationTypeLabel
} from '../utils';
import { StationSalesCell } from '../StationSalesCell';

import { StationRowProps } from './StationRow.types';
import { StationFuelPriceCell } from '../StationFuelPriceCell';

export const StationRow = ({ station, binding, isOkko, fuelTypes, rowType, hideSales = false }: StationRowProps) => {
  const getRowClass = (isOkko: boolean, rowType?: string) => {
    if (isOkko) return 'data-row okko-row';
    if (rowType === 'unbound-competitor') return 'data-row competitor-row unbound-row';
    return 'data-row competitor-row';
  };

  const rowClass = getRowClass(isOkko, rowType);

  return (
    <tr className={rowClass}>
      <td className="data-cell brand-cell">{station.brand}</td>
      <td className="data-cell unicode-cell">{station.unicode}</td>
      <td className="data-cell address-cell">{station.address}</td>

      <td className="data-cell photo-cell">
        {station.photoUrl && (
          <Button size="small" onClick={() => window.open(station.photoUrl, '_blank')} className="photo-link">
            <Launch />
          </Button>
        )}
      </td>

      <td className="data-cell date-cell">
        {station.startDate && new Date(station.startDate).toLocaleDateString('uk-UA')}
      </td>

      <td className="data-cell influence-cell">{getInfluenceTypeLabel(binding?.influence) || ''}</td>

      <td className="data-cell distance-cell">{binding?.distance ?? ''}</td>

      <td className="data-cell location-cell">{getLocationTypeLabel(binding?.locationType) || ''}</td>

      {!hideSales && (
        <td className="data-cell station-detail-price-cell">
          {isOkko && station.sales && <StationSalesCell sales={station.sales} />}
        </td>
      )}

      {fuelTypes.map(fuelType => {
        return (
          <td key={fuelType} className="data-cell station-detail-price-cell">
            <StationFuelPriceCell
              fuelType={fuelType}
              fuelPrice={station.fuelPrices?.[fuelType]}
              isOkko={isOkko}
              hideSales={hideSales}
            />
          </td>
        );
      })}
    </tr>
  );
};
